import { useEffect, useState } from 'react';
import { collection, query, orderBy, limit, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';

const PUBLIC_PRESETS_COLLECTION = 'publicLinkagePresets';
const COMMUNITY_QUERY_LIMIT = 80;

export function useCommunityLinkagePresets() {
  const [communityPresets, setCommunityPresets] = useState([]);
  const [communityListError, setCommunityListError] = useState('');

  useEffect(() => {
    const q = query(
      collection(db, PUBLIC_PRESETS_COLLECTION),
      orderBy('createdAt', 'desc'),
      limit(COMMUNITY_QUERY_LIMIT),
    );
    const unsub = onSnapshot(
      q,
      (snap) => {
        setCommunityListError('');
        const rows = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
        setCommunityPresets(rows);
      },
      (err) => {
        console.warn('publicLinkagePresets subscription failed (check Firestore rules):', err);
        setCommunityPresets([]);
        setCommunityListError(
          err?.code === 'permission-denied'
            ? 'Community linkage list is blocked by Firestore rules. Merge shokiq-pwa/config/firestore-publicLinkagePresets.rules.fragment into your rules in the Firebase console, then Publish.'
            : '',
        );
      },
    );
    return () => unsub();
  }, []);

  return { communityPresets, communityListError };
}
